import PropTypes from 'prop-types';

const PREVIEW_CARD = {
  imageSize: 60,
  borderRadius: 4,
  marginRight: 12,
};

const DeckPreviewCard = ({ imageUrl }) => {
  if (!imageUrl) return null;

  return (
    <img
      src={imageUrl}
      alt="Preview card"
      width={PREVIEW_CARD.imageSize}
      height={PREVIEW_CARD.imageSize}
      style={{
        borderRadius: PREVIEW_CARD.borderRadius,
        display: 'block',
        marginRight: PREVIEW_CARD.marginRight,
        flexShrink: 0,
        objectFit: 'cover',
      }}
    />
  );
};

DeckPreviewCard.propTypes = {
  imageUrl: PropTypes.string,
};

export default DeckPreviewCard;
